// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3pqej","normal":"styles_normal__2rk1Y","error":"styles_error__2pGTd","confirm":"styles_confirm__2MQ_7","disabled":"styles_disabled__2JX2m"};